import React from 'react';
import PropTypes from 'prop-types';

// Styles
import styles from './post.scss';

const Post = ({
  title,
  link,
  image,
  headingLevel,
  publicationDate,
  excerpt,
  byline,
}) => {
  const HeadingTag = `h${headingLevel}`;

  return (
    <a
      href={link}
      className={styles.post}
      target="_blank"
    >
      {image && 'false' !== image &&
        <figure className={styles.figure}>
          <img src={image} alt="" className={styles.image} />
        </figure>
      }
      <HeadingTag className={styles.title}>
        {title}
      </HeadingTag>
      <div className={styles.byline}>
        {byline}
      </div>
      <div className={styles.excerpt}>
        {excerpt}
      </div>
      <div className={styles.publicationDate}>
        <span className="screen-reader-text">
          Published on
        </span>
        {/* @todo this could be a <time> if we had a UTC publication date */}
        {publicationDate}
      </div>
    </a>
  );
};

Post.defaultProps = {
  headingLevel: 2,
  image: false,
};

Post.propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  headingLevel: PropTypes.number,
  publicationDate: PropTypes.string.isRequired,
  byline: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
};

export default Post;



// WEBPACK FOOTER //
// ./app/components/post/index.js